import { ResourceName } from '../resource-name';

export const ReferralGate = {
  resource: ResourceName.referral,
  actions: {
    refer: 'refer',
  },
};

export type ReferralActionTypes = {
  refer: {
    request: ReferRequest;
    response: undefined;
  };
};

export interface ReferRequest {
  workspaceId: string;
  personalBoardId: string;
  email: string;
}
